import React, { Component } from 'react'
import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
class CheckChangePassword extends Component {
  constructor(props) {
    super(props);
  }
  backToChangePassword = () => {
    this.props.changePassword();
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isOpen} className={'modal-lg ' + this.props.className}>
          <ModalHeader>
            Yêu cầu đổi mật khẩu
          </ModalHeader>
          <ModalBody>
              <Row>
                <Col sm="12">
                  Quản trị viên yêu cầu bạn đổi mật khẩu trước khi thao tác hệ thống
                </Col>
              </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.backToChangePassword}>Đổi mật khẩu</Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default CheckChangePassword


// WEBPACK FOOTER //
// ./src/components/Header/_CheckChangePassword.js